module.exports = __webpack_public_path__ + "img/img2.43f1258e.svg";